module.exports = __webpack_public_path__ + "images/emoji/eggplant.b375754ce916f4902bc6.png";